export default {
  select_size: 'Selectează o mărime',
  required: 'Obligatoriu',
  required_missing: 'Obligatoriu — te rugăm să faci o selecție',
  optional: 'Opțional',
  select_up_to: 'Selectează până la {{maxCount}}',
};
